/* eslint-disable prettier/prettier */
import { useNavigate } from 'react-router-dom';
import { BookCopy, BookType, Calendar1 } from 'lucide-react';
import { FeatureCard } from '../../components/ui/FeatureCard';

export const ComparePage = () => {
  const navigate = useNavigate();
  const compareTools = [
    {
      icon: <BookType />,
      title: 'Compare PV',
      description: 'Compare two versions of a treaty',
      path: '/compare/compare-pv',
    },
    {
      icon: <BookCopy />,
      title: 'Compare PP',
      description: 'Compare two programs by year',
      path: '/compare/compare-pp',
    },
    {
      icon: <Calendar1 />,
      title: 'Compare PY',
      description: 'Compare stats versus prior year',
      path: '/compare/compare-py',
    },
  ];

  return (
    <div>
      <h1 className="text-4xl font-bold text-center sm:text-left text-primary">Compare Tools</h1>
      <div className="flex flex-col gap-6 pt-7">
        {compareTools.map((tool, index) => (
          <FeatureCard
            key={index}
            icon={tool.icon}
            description={tool.description}
            title={tool.title}
            onClick={() => navigate(tool.path)}
          />
        ))}
      </div>
    </div>
  );
};
